module.exports = __webpack_public_path__ + "img/np.9d62130c.svg";